import { memo } from 'react'

import ConfirmPopover, { type ConfirmPopoverProps } from '@components/ConfirmPopover'
import RadioList, { type RadioListProps } from '@components/RadioList'

export type RadioListConfirmPopoverProps = Omit<ConfirmPopoverProps, 'children'> & RadioListProps

const RadioListConfirmPopover = ({ value, onChange, items, alignLeft, ...rest }: RadioListConfirmPopoverProps) => {
  // eslint-disable-next-line react/self-closing-comp
  return (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    <ConfirmPopover {...rest}>
      <RadioList value={value} onChange={onChange} items={items} alignLeft={alignLeft} />
    </ConfirmPopover>
  )
}

export default memo(RadioListConfirmPopover)
